import { faPlusCircle, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import { Spinner } from "reactstrap";
import "nepali-datepicker-reactjs/dist/index.css"
import "../../../assets/scss/nepali-calander.scss"
import moment from "moment";
import DatepickerNepali from "../../Datepicker-nepali";
import { NepaliDatePicker } from "nepali-calander";

const { adToBs, bsToAd } = require('@sbmdkl/nepali-date-converter');

class AddTermsModal extends Component {
  state = {};

  validateDate = (date) => {
    const endDate = new Date(date);
    endDate.setDate(endDate.getDate() + 1);
    const newDate = endDate.toISOString().split("T")[0];
    return newDate;
  };

  render() {
    const isValidDateString = (dateStr) => {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(dateStr)) return false;
      const date = new Date(dateStr);
      return !Number.isNaN(date.getTime());
    };

    const formatToBS = (adDateStr) => {
      try {
        return isValidDateString(adDateStr)
          ? adToBs(adDateStr)
          : adToBs(new Date().toISOString().split("T")[0]);
      } catch (err) {
        // console.warn("adToBs failed:", err);
        return adToBs(new Date().toISOString().split("T")[0]); // fallback
      }
    };

    // console.log(this.props, "POrops")

    const { idx, newTerms, minStartDate, maxEndDate, handleTermDataChange } = this.props;
    const prevTerm = idx > 0 ? newTerms[idx - 1] : null;

    // const minAd = prevTerm && prevTerm.endDate !== ""
    //   ? this.validateDate(prevTerm.endDate)
    //   : minStartDate;

    // const maxAd = maxEndDate;

    // const minBs = adToBs(minAd);
    // const maxBs = adToBs(maxAd);

    const isDisabled = idx !== 0 && (!prevTerm || prevTerm.endDate === "");

    return (
      <>
        <div
          className="container-fluid tt-widgetContent-tab-holder "
          style={{ maxHeight: "81vh", height: "auto", overflowX: "scroll" }}
        >
          <table className="table table-bordered table-striped">
            <thead className="tt-group-header">
              <tr>
                <th>
                  {this.props.termAlias} Name{" "}
                  <span className="tt-assessment-module-mandatory">*</span>
                </th>
                <th>
                  Start Date{" "}
                  <span className="tt-assessment-module-mandatory">*</span>
                </th>
                <th>
                  End Date{" "}
                  <span className="tt-assessment-module-mandatory">*</span>
                </th>
                <th>
                  Weekday{" "}
                  <span className="tt-assessment-module-mandatory">*</span>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {this.props.newTerms.map((term, idx) => {
                // console.log(term, "Term values")
                const { startDate, endDate, date_toggle } = term;


                const start_date_nepali = date_toggle ? formatToBS(startDate) : "";
                const end_date_nepali = date_toggle ? formatToBS(endDate) : "";

                return (
                  // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                  <tr key={idx}>
                    <td style={{ width: "160px" }}>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={term.name}
                        onChange={(e) =>
                          this.props.handleTermDataChange("name", e.target.value, idx)
                        }
                      />
                    </td>
                    <td className="datePicker">
                      <NepaliDatePicker
                        type="input"
                        calendarMode={localStorage.getItem('calendar-mode')}
                        showToggle={true}
                        showNationalHoliday={false}
                        events={[]}
                        onDateSelect={(date) => {
                          this.handleTermDataChange(
                            "startDate",
                            {
                              target: { value: date.ad.date, name: "startDate" },
                            },
                            idx
                          )
                        }
                        }
                        value={startDate}
                        minDate={
                          idx === 0
                            ? this.props.minStartDate
                            : this.props.newTerms[idx - 1].endDate !== ""
                              ? this.validateDate(
                                this.props.newTerms[idx - 1].endDate
                              )
                              : this.props.minStartDate
                        }
                        maxDate={this.props.maxEndDate}
                        disabled={
                            idx === 0
                              ? false
                              : this.props.newTerms[idx - 1].endDate === ""
                          }
                      /> 
                      
                    </td>

                    <td className="datePicker">
                        <NepaliDatePicker
                        type="input"
                        calendarMode={localStorage.getItem('calendar-mode')}
                        showToggle={true}
                        showNationalHoliday={false}
                        events={[]}
                        onDateSelect={(date) => {
                          this.handleTermDataChange(
                            "endDate",
                            {
                              target: { value: date.ad.date, name: "endDate" },
                            },
                            idx
                          )
                        }
                        }
                        value={endDate}
                        minDate={
                            term.startDate !== ""
                              ? term.startDate
                              : this.props.minStartDate
                          }
                          maxDate={this.props.maxEndDate}
                          disabled={term.startDate === ""}
                      /> 
                    </td>

                    <td>
                      {this.props.weekDays
                        ? this.props.weekDays.map((day, weekIdx) => {
                          return (
                            <div
                              // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                              key={weekIdx}
                              className="row tt-weekday-wrapper"
                              style={{ cursor: "pointer" }}
                            >
                              <input
                                type="checkbox"
                                id={day.id}
                                onChange={(e) =>
                                  this.props.handleChangeForNewTermCheckBox(
                                    e,
                                    idx,
                                    day.id
                                  )
                                }
                              />
                              <label className="ml-2" htmlFor={day.id}>
                                {day.name}
                              </label>
                            </div>
                          );
                        })
                        : null}
                    </td>
                    <td className="pl-2">
                      {/* commented currently as no np date picker is implemented */}
                      {/* <div className="d-flex justify-content-start align-items-center gap-2">

                        <span>
                          <b>A.D.</b>
                        </span>
                        <label className="switch">
                          <input
                            name="date_toggle"
                            type="checkbox"
                            defaultChecked={false}
                            onChange={(e) => this.props.handleTermDataChange("date_toggle", e.target.checked, idx)}
                          />
                          <span className="slider round" />
                        </label>
                        <span>
                          <b>B.S.</b>
                        </span>
                      </div> */}
                      <FontAwesomeIcon
                        icon={faTrashAlt}
                        className="removeMcqOption mr-2"
                        onClick={(e) => this.props.deleteTermRow(e, idx)}
                      />

                      {idx === this.props.newTerms.length - 1 ? (
                        <FontAwesomeIcon
                          icon={faPlusCircle}
                          className="addMcqOption"
                          onClick={(e) => this.props.addTermRow(e)}
                        />
                      ) : null}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div >
        {
          this.props.showSpinner ? (
            <div className="fullWindow-Spinner">
              <div>
                <Spinner color="white" />
              </div>
              <div style={{ fontSize: "16px", marginTop: "15px" }}>
                Please Wait.Adding Terms ...
              </div>
            </div>
          ) : null
        }
      </>
    );
  }
}

export default AddTermsModal;
